export default __webpack_public_path__ + "images/4N.b7148b6.png";